module.exports = __webpack_public_path__ + "974a6725bc66ba76f5999f092fd3e486.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/step1.png
// module id = 669
// module chunks = 0